import React, { useEffect, useState } from "react";
import { urlArchivo } from "../utils/upload";

// Imagen guardada en un archivo privado: se baja con la sesión iniciada y se muestra desde memoria.
function ImagenProtegida({ archivo, alt, style }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let cancelado = false;
    let urlLocal = "";
    const token = localStorage.getItem("token");
    fetch(urlArchivo(archivo), { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((res) => (res.ok ? res.blob() : null))
      .then((blob) => {
        if (!blob || cancelado) return;
        urlLocal = window.URL.createObjectURL(blob);
        setSrc(urlLocal);
      })
      .catch(() => {});
    return () => {
      cancelado = true;
      if (urlLocal) window.URL.revokeObjectURL(urlLocal);
    };
  }, [archivo]);
  if (!src) return <div style={{ ...style, minHeight: 40, color: "#8993a1", fontSize: "0.8rem" }}>Cargando imagen…</div>;
  return <img src={src} alt={alt} style={style} />;
}

export default ImagenProtegida;
